(()=>{
  const wide=matchMedia('(min-width:1024px)');
  const bindMenus=()=>{
    document.querySelectorAll('.header details[level="top"]').forEach(menu=>{
      if(menu.dataset.fvHover)return;menu.dataset.fvHover='true';let timer;
      menu.querySelector(':scope > summary')?.addEventListener('click',event=>{
        if(!wide.matches||event.detail===0||event.pointerType==='touch'||event.sourceCapabilities?.firesTouchEvents)return;
        const link=event.currentTarget.dataset.link;
        if(link){event.preventDefault();event.stopImmediatePropagation();window.location.assign(link);}
      },true);
      menu.addEventListener('mouseenter',event=>{
        if(!wide.matches||event.sourceCapabilities?.firesTouchEvents)return;
        clearTimeout(timer);
        document.querySelectorAll('.header details[level="top"][open]').forEach(other=>{if(other!==menu)other.open=false;});
        menu.open=true;
      });
      menu.addEventListener('mouseleave',()=>{if(wide.matches){clearTimeout(timer);timer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},180);}});
    });
  };
  const bindFooter=()=>{
    const small=matchMedia('(max-width:767px)');
    const update=()=>document.querySelectorAll('.fc-footer-links').forEach(row=>{row.open=!small.matches;});
    update();small.addEventListener('change',update);
  };
  class FovielPairing extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;
      this.form=this.querySelector('form');this.button=this.form.querySelector('button[type="submit"]');
      this.rows=[...this.querySelectorAll('[data-fv-pair-row]')];
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(value/100);
      this.update=()=>{
        let total=0,count=0;
        this.rows.forEach(row=>{
          const included=row.querySelector('[data-fv-include]').checked,select=row.querySelector('select'),option=select.selectedOptions[0];
          const price=Number(option?.dataset.price||0);row.querySelector('[data-fv-row-price]').textContent=money(price);
          row.querySelector('input[type="hidden"]').disabled=!included;
          select.dataset.included=String(included);
          if(included&&option&&!option.disabled){total+=price;count++;}
        });
        this.querySelector('[data-fv-total]').textContent=money(total);this.button.disabled=count===0;
      };
      this.form.addEventListener('change',this.update);
      this.form.addEventListener('submit',event=>{
        this.update();if(this.button.disabled){event.preventDefault();return;}
        this.rows.forEach(row=>{if(!row.querySelector('[data-fv-include]').checked)row.querySelector('select').disabled=true;});
        this.button.textContent=this.button.dataset.adding;
      });
      const info=this.closest('.product__info');
      info?.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
        if(form===this.form)return;
        form.addEventListener('variant:change',event=>{
          const id=event.detail?.variant?.id,select=this.querySelector('[data-main-product] select');
          if(id&&select&&[...select.options].some(option=>option.value===String(id))){select.value=String(id);this.update();}
        });
      });
      this.update();
      const description=this.parentElement?.querySelector('[data-fc-full-description]'),product=this.closest('.product');
      if(description&&product)product.after(description);
    }
  }
  if(!customElements.get('foviel-pairing'))customElements.define('foviel-pairing',FovielPairing);
  class FovielSpotlight extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;this.cards=[...this.querySelectorAll('[data-fv-spotlight-card]')];this.index=0;
      const key='foviel-style-dismissed-until';
      const dismissed=()=>{try{return Number(sessionStorage.getItem(key)||0)>Date.now();}catch{return false;}};
      const hide=()=>this.cards.forEach(card=>card.hidden=true);
      this.show=()=>{
        hide();
        if(!this.isConnected||!this.cards.length||dismissed())return;
        const blocked=document.hidden||document.querySelector('dialog[open],.drawer[open],cart-drawer[open]');
        if(blocked){this.timer=setTimeout(this.show,10000);return;}
        this.cards[this.index++%this.cards.length].hidden=false;
        this.timer=setTimeout(()=>{hide();this.timer=setTimeout(this.show,45000);},8500);
      };
      this.addEventListener('click',event=>{if(event.target.closest('.fc-popular-close')){clearTimeout(this.timer);hide();try{sessionStorage.setItem(key,String(Date.now()+30*60*1000));}catch{}}});
      this.onVisibility=()=>{clearTimeout(this.timer);hide();if(!document.hidden&&!dismissed())this.timer=setTimeout(this.show,12000);};
      document.addEventListener('visibilitychange',this.onVisibility);
      if(!dismissed())this.timer=setTimeout(this.show,12000);
    }
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.onVisibility);}
  }
  if(!customElements.get('foviel-style-spotlight'))customElements.define('foviel-style-spotlight',FovielSpotlight);
  const init=()=>{bindMenus();bindFooter();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
